export const FORMS_TYPES = {
  FOMR_UPLOAD: "[Forms] FOMR_UPLOAD"
};
